import React, { useEffect, useMemo, useState, useCallback } from "react";
import toast, { Toaster } from "react-hot-toast";
import { getInvoiceDetailsByUUID, createShipping, KeyValueDeliveryPersonList } from "../../../services/index";
import { useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import PaymentIcon from "@mui/icons-material/Payment";
import LocalShippingRoundedIcon from "@mui/icons-material/LocalShippingRounded";
import Modal from "react-bootstrap/Modal";
import EditIcon from "@mui/icons-material/Edit";
import Button from "@mui/material/Button";
import Select from "react-select";
import { getFormattedNumber } from "../../utils/textUtils";
import { INVOICES_URL } from "../../../CONSTANTS";
import PaginationDataTable from "../../Common/PaginationDataTable";
import { FaThumbsUp } from "react-icons/fa";
import { ApproveInvoiceByUuid } from "../../../services/Sales/InvoiceServices";
import { ThumbUpAlt, ThumbUpAltOutlined } from "@mui/icons-material";


const InvoiceList = (props) => {
    let navigate = useNavigate();
    var curr = new Date();
    curr.setDate(curr.getDate());
    var date1 = curr.toISOString().substring(0, 10);
    const [filteredData, setFilteredData] = useState([]);
    const [driverOptions, setDriverOptions] = useState([]);
    const [refreshFlag, setRefreshFlag] = useState(0);


    const [shipInfo, setShipInfo] = useState({});
    const [show2, setShow2] = useState(false);
    const handleClose2 = () => {
        setShow2(false);
        setShipInfo({});
    };

    const handleRefresh = useCallback(() => {
        setRefreshFlag(refreshFlag + 1);
    }, [refreshFlag]);


    const columns = useMemo(
        () => [
            {
                name: "INVOICE NO.",
                selector: (data) => data.invoiceNo,
                style: { color: "#007bff" }
            },
            {
                name: "SALES NO.",
                selector: (data) => data.salesOrderNo,
            },
            {
                name: "INVOICE DATE",
                selector: (data) => data.invoiceDate,
            },
            {
                name: "WAREHOUSE TITLE",
                selector: (data) => data?.warehouseTitle,
                width: "200px",
            },

            {
                name: "CUSTOMER NAME",
                selector: (data) => <div>{data.customerTitle}</div>,
                width: "300px",
            },

            {
                name: "AMOUNT",
                selector: (data) => " ₹ " + getFormattedNumber(data.amount),
            },
            {
                name: "BALANCE DUE",
                selector: (data) => getFormattedNumber(data.balanceDue),
            },
            {
                name: "PAY || SHIP",
                selector: (data) => (
                    <div className="text-center">
                        {data.status === "Unpaid" ? (
                            <>
                                <PaymentIcon
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                        navigate("/SalesPayment/" + data.recordId, {
                                            state: { id: data.recordId },
                                        })
                                    }
                                />
                            </>
                        ) : (
                            <Tooltip title="Paid" arrow placement="top">
                                <PaymentIcon style={{ color: "greenyellow" }} />
                            </Tooltip>
                        )}
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        {data.isShipped ? (
                            <Tooltip
                                title={
                                    <>
                                        Shipped <br />
                                        {data.deliveryPersonName}
                                        <br />
                                        {data.deliveryPersonNumber}
                                    </>
                                }
                                arrow
                                placement="top"
                            >
                                <LocalShippingRoundedIcon style={{ color: "greenyellow" }} />
                            </Tooltip>
                        ) : (
                            <>
                                <LocalShippingRoundedIcon style={{ cursor: "pointer" }} onClick={() => handleShipment(data)} />
                            </>
                        )}
                    </div>
                ),
            },
            {
                name: "ACTION",
                selector: (row) => (
                    <div style={{ display: "flex", width: "50px", justifyContent: "space-between" }}>
                        {row.isShipped || row.einvoiceGenerated || row.ewayBillGenerated ? (
                            <>-</>
                        ) : (
                            <>
                                <EditIcon
                                    style={{ fontSize: "15px", cursor: "pointer" }}
                                    onClick={() =>
                                        navigate(`/invoiceEdit/`, {
                                            state: {
                                                invoiceId: row.recordId,
                                                invoiceEdit: true,
                                            },
                                        })
                                    }
                                />
                            </>
                        )}
                        {/* row.ewayBillGenerated */}
                        {(true && row.isBatchApproved === false) ? (
                            <>
                                <ThumbUpAlt
                                    style={{
                                        fontSize: '15px',
                                        cursor: 'pointer',
                                        color: 'greenyellow',
                                    }}
                                    onClick={() =>
                                        handleApproveInvoice(row.recordId)
                                    }
                                />
                            </>
                        ) : (
                            <>
                            </>
                        )}


                    </div>

                ),
            },
        ], [handleRefresh]
    )

    useEffect(() => {
        // InvoicesList();

        KeyValueDeliveryPersonList().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d,
                    label: d.title,
                }));
                setDriverOptions(options);
            }
        });
    }, []);


    const handleApproveInvoice = (recordId) => {
        ApproveInvoiceByUuid(recordId).then(
            (res) => {
                toast.success(res.message);
            }
        ).catch((err) => toast.error(err))
        setRefreshFlag((prev) => prev + 1);

    }

    const handleRowClick = (row) => {
        if (props.onRowClicked) {
            props.onRowClicked(row);
        }
        const recordId = row.recordId;
        if (recordId) {
            navigate(`/invoices/${recordId}`);
        }
    };

    const handleShipment = (row) => {
        getInvoiceDetailsByUUID(row.recordId).then((res) => {
            if (res.errorCode === 0) {
                let d = res.responsePacket;
                d.shipDate = date1;
                setShipInfo(d);
                setShow2(true);
            }
        });
    };

    const saveShipment = () => {
        let data = {
            isShipped: true,
            shipperName: "",
            salesShippingStatus: "",

            deliveryPersonId: shipInfo.driver.value?.recordId,
            deliveryPersonName: shipInfo.driver.label,
            deliveryPersonNumber: shipInfo.driver.value?.phone,

            invoiceId: shipInfo.recordId,
            invoiceNo: shipInfo.invoiceNo,
            shippingDate: shipInfo.shipDate,
            shippingItemList: shipInfo.itemsList,
        };

        createShipping(data).then((res) => {
            if (res.errorCode === 0) {
                toast.success(res.message);
                handleClose2();
            } else {
                toast.error(res.message);
            }
        });
    };
    const handleClickNew = () => {
        navigate('/directInvoices', { state: { directInvoice: true } });
    };
    return (
        <>
            <Modal show={show2} onHide={handleClose2} size="sm">
                <Modal.Header>Shipping for {shipInfo.invoiceNo}</Modal.Header>
                <Modal.Body>
                    <table>
                        <tr>
                            <td style={{ width: "100px" }}>Date:</td>
                            <td>
                                <input type="date" value={shipInfo.shipDate} className="form-control" onChange={(e) => setShipInfo({ ...shipInfo, shipDate: e.target.value })} />
                            </td>
                        </tr>
                        <tr>
                            <td>Driver:</td>
                            <td>
                                <Select options={driverOptions} onChange={(e) => setShipInfo({ ...shipInfo, driver: e })} value={shipInfo.driver} />
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>{shipInfo?.driver?.value?.phone}</td>
                        </tr>
                    </table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="contained" onClick={saveShipment}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>

            <div style={{ height: 500, width: "100%" }}>
                {filteredData && filteredData ? (
                    <PaginationDataTable
                        paginationUrl={
                            INVOICES_URL() + "getAllRecords"
                        }
                        serverSidePagination={true}
                        search={true}
                        pagination={false}
                        columns={columns}
                        onRowClicked={handleRowClick}
                        onNewClicked={handleClickNew}
                    />
                ) : (
                    <></>
                )}
            </div>
            <Toaster />
        </>
    );
};

export default InvoiceList;
